import { useCallback } from "react";
import { useInView } from "react-intersection-observer";

const useObserver = (props = {}) => {

  const {
    threshold = 0,
    rootMargin = '-75px 0px',
  } = props

  const { ref, inView,  } = useInView({
    threshold,
    rootMargin,
    triggerOnce: true
  });

  const Observer = useCallback(() => (
    <div style={{ height: '200px' }} ref={ref}></div>
  ), [ref])

  return { Observer, inView }

}

export default useObserver